var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobileicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 34.9999C10 35.9999 10.6667 36.6666 11.6667 36.6666H28.3333C29.3333 36.6666 30 35.9999 30 34.9999V33.3333H10V34.9999Z",
    fill: "#009EF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.3333 3.33325H11.6667C10.6667 3.33325 10 3.99992 10 4.99992V33.3332H30V4.99992C30 3.99992 29.3333 3.33325 28.3333 3.33325Z",
    fill: "#009EF7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 6.66659C19.0002 6.66659 18.3335 5.99992 18.3335 4.99992V3.33325H21.6668V4.99992C21.6668 5.99992 21.0002 6.66659 20.0002 6.66659Z",
    fill: "#009EF7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileicon);
export default __webpack_public_path__ + "static/media/mobileicon.d9ab66a1d0059d91ef762f2ea5b966eb.svg";
export { ForwardRef as ReactComponent };